import { render, staticRenderFns } from "./RefClaimForm.vue?vue&type=template&id=0eadcac1&"
import script from "./RefClaimForm.vue?vue&type=script&lang=js&"
export * from "./RefClaimForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports